import { IAppState } from '../../common/state';

export const selectPageNumber = (state: IAppState): number => {
  const {
    results: { jsonQuery },
  } = state;

  return jsonQuery.page && jsonQuery.page.value ? Number(jsonQuery.page.value) : 1;
};
